import { reducer, union } from "ts-action";
import { on } from "ts-action-immer";
import forSourceNameReducer, {
  ForSourceNameState,
  forSourceNameInitialState,
} from "./forSourceName";

import * as AC from "../actionCreators";
import { X2yController } from "../types";

export type SliceState = Record<X2yController, ForSourceNameState>;

const initialState: SliceState = {
  users2Roles: forSourceNameInitialState,
  templates2Roles: forSourceNameInitialState,
  modules2Roles: forSourceNameInitialState,
  users2NotificationTemplates: forSourceNameInitialState,
};

const Reducer = reducer(
  initialState,
  on(...union(...Object.values(AC)), (state, action) => {
    const { controller } = action.payload;
    state[controller] = forSourceNameReducer(state[controller], action);
  })
);

export default Reducer;
